import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    box-shadow: 0px 6px 9px -7px rgba(0, 0, 0, 0.25);
    .MuiTabs-indicator {
      height: 3px;
      background-color: ${colors.leaf};
    }
  `,
  tab: css`
    &.MuiTab-root {
      text-transform: capitalize;
      font-family: 'Proxima Nova', Arial, Helvetica, sans-serif;
      font-size: 16px;
      color: ${colors.prussian};
    }
    &.Mui-selected {
      color: ${colors.prussian} !important;
      font-weight: bold;
    }
  `,
};

export default styles;
